module.exports = __webpack_public_path__ + "static/CMS-Präs-7ae09acbcbd326d8f4350e88e346d3a2.pdf";